import Vue from 'vue';
import store from '@/store';
import router from '@/routes';
import _ from 'lodash';

let nextTabId = 0;

export default {
  tableQuery(state: any, data: any) {
    let statePath = state.table.query;
    if(state.table.activeTab !==0 ){
      statePath = state.table.activeReports.find(report=>report.tabId === state.table.activeTab).state.tableQuery
    }

    Vue.set(statePath, data.name, data.value);

    if(state.table.activeTab ===0) {
      window.localStorage.setItem('table-query', JSON.stringify(_.omit(state.table.query,['search'])));
    }
  },

  tableQueryTemporary(state: any, data: any) {
    let statePath = state.table.queryTemporary;
    if(state.table.activeTab !==0 ){
      statePath = state.table.activeReports.find(report=>report.tabId === state.table.activeTab).state.tableQueryTemporary
    }

    Vue.set(statePath, data.name, data.value);
  },

  tableQuerySearchTemporary(state: any, data: any) {
    if(state.table.activeTab !==0 ){
      const path = state.table.activeReports.find(report=>report.tabId === state.table.activeTab).state.tableQueryTemporary
      return Vue.set(path, 'search', data);
    }

    if(!state.table.queryTemporary.search){
      Vue.set(state.table.queryTemporary, 'search', {});
    }

    if(state.user.reportSearchSetting==='perTab') {
      if(!state.table.queryTemporary.search[state.table.query.groupBy]){
        Vue.set(
          state.table.queryTemporary,
          'search',
    {
            ...state.table.queryTemporary.search,
            [state.table.query.groupBy]:{}
          }
        );
      }
      return Vue.set(
        state.table.queryTemporary.search,
        state.table.query.groupBy,
        data,
      );
    }
    // for case state.user.reportSearchSetting==='allTabs' and default
    Vue.set(state.table.queryTemporary, 'search', data);
  },
  tableQuerySearch(state: any) {
    if(state.table.activeTab !==0 ){
      const statePath = state.table.activeReports.find(report=>report.tabId === state.table.activeTab).state
      return Vue.set(statePath['tableQuery'], 'search', JSON.parse(JSON.stringify(statePath.tableQueryTemporary.search)));
    }
    if(!state.table.query.search){
      Vue.set(state.table.query, 'search', {});
    }
    if(state.user.reportSearchSetting==='perTab') {
      if (!state.table.query.search[state.table.query.groupBy]) {
        Vue.set(
          state.table.query,
          'search',
    {
            ...state.table.query.search,
            [state.table.query.groupBy]: {}
          }
        );
      }
      return Vue.set(
        state.table.query.search,
        state.table.query.groupBy,
        JSON.parse(JSON.stringify(state.table.queryTemporary.search[state.table.query.groupBy] || {}))
      )
    }

    // for case state.user.reportSearchSetting==='allTabs' and default
    Vue.set(
      state.table.query,
      'search',
      JSON.parse(JSON.stringify(state.table.queryTemporary.search))
    )
  },
  clearTableQuerySearch(state: any) {
    Vue.set(state.table.query, 'search', {})
    Vue.set(state.table.queryTemporary, 'search', {})
    state.table.activeReports.forEach(report => {
      Vue.set(report.state.tableQuery, 'search', {})
      Vue.set(report.state.tableQueryTemporary, 'search', {})
    })
  },

  replaceTableQuery(state: any, data: { query:any, notSetToLocalStorage:boolean}) {
    state.table.query = data.query;
    if(state.table.activeTab ===0) {
      window.localStorage.setItem('table-query', JSON.stringify(_.omit(state.table.query,['search'])));
    }
  },

  tablePeriodForCurrentTab(state: any, period: any) {
    let statePath = state.table.query;
    if(state.table.activeTab !==0 ){
      statePath = state.table.activeReports.find(report=>report.tabId === state.table.activeTab).state.tableQuery
    }

    Vue.set(statePath, 'from', period.from);
    Vue.set(statePath, 'to', period.to);
    Vue.set(statePath, 'date', period.date);
    Vue.set(statePath, 'timezone', period.timezone || state.user.defaultTimezone);
    Vue.set(statePath, 'compareEnabled', period.compareEnabled);
    Vue.set(statePath, 'compareFrom', period.compareFrom);
    Vue.set(statePath, 'compareTo', period.compareTo);
    Vue.set(statePath, 'compareDate', period.compareDate);
    
    if(state.table.activeTab ===0) {
      window.localStorage.setItem('table-query', JSON.stringify(_.omit(state.table.query,['search'])));
    }
  },

  tablePeriodTemporaryForCurrentTab(state: any, period: any) {
    let statePath = state.table.queryTemporary;
    if(state.table.activeTab !==0 ){
      statePath = state.table.activeReports.find(report=>report.tabId === state.table.activeTab).state.tableQueryTemporary;
    }
    Vue.set(statePath, 'from', period.from);
    Vue.set(statePath, 'to', period.to);
    Vue.set(statePath, 'date', period.date);
    Vue.set(statePath, 'timezone', period.timezone || state.user.defaultTimezone);
    Vue.set(statePath, 'compareEnabled', period.compareEnabled);
    Vue.set(statePath, 'compareFrom', period.compareFrom);
    Vue.set(statePath, 'compareTo', period.compareTo);
    Vue.set(statePath, 'compareDate', period.compareDate);
  },

  tableTotal(state: any, total: number) {
    state.table.total = total;
  },

  tableOffsetForCurrentTab(state: any, data: any) {
    let statePath = state.table.query;
    if(state.table.activeTab !==0 ){
      statePath = state.table.activeReports.find(report=>report.tabId === state.table.activeTab).state.tableQuery
    }

    if(!statePath.offset){
      Vue.set(statePath, 'offset', {});
    }
    Vue.set(statePath.offset, data.groupBy, data.value);
  },

  tableLastGroupBy(state: any, data: any) {
    Vue.set(state.table, 'lastActiveTab', data);
  },

  tableExportParams(state: any, data: any) {
    state.table.exportParams = data;
  },

  tableNextReportTreeLevel(state: any, value: number) {
    state.table.nextReportTreeLevel = value;
  },

  tablePreviewLink(state: any, value: any) {
    state.table.previewLink = value;
  },

  tableDrildownFilter(state: any, drilldown: any) {
    state.table.drilldownFilter = drilldown;
  },

  tableDrilldown(state: any, drilldown: any) {
    state.table.drilldown = drilldown;
  },

  //TODO: move to actions
  tableActiveTab(state: any, data: { tabId: number, url: string}) {
    const tableActiveTab = router.currentRoute.name.indexOf('app.profile') === 0
      ? -1
      : state.table.activeTab;

    store.commit('tableActiveTabStackPush', tableActiveTab);

    if(state.table.activeTab !== data.tabId) {
      // if we move from another tab
      if(state.table.activeTab) {
        let currentTabIndex  = state.table.activeReports.findIndex((e: any) => e.tabId ===  state.table.activeTab);

        if(currentTabIndex !== -1) {
          let currentTab = state.table.activeReports[currentTabIndex];

          if(data.url) {
            Vue.set(currentTab,'url',data.url);
          }

          Vue.set(state.table.activeReports, currentTabIndex, currentTab);
        }


      }

      // if we move to tab
      if(data.tabId > 0) {

      } else {
        // if we move to common page
        Vue.set(state.table,'selectedReport', null);

      }

      Vue.set(state.table,'activeTab' , data.tabId);
    }
  },

  tableCloseTab(state: any, closedTabId: number) {
    state.table.activeReports = state.table.activeReports.filter((e: any) =>  e.tabId !== closedTabId);

    store.commit('tableActiveTabStackPop', closedTabId);
  },

  setActiveReportColumns(state, { columns, id = state.table.activeTab }) {
    const statePath = state.table.activeReports?.find(report=>report.tabId === id)?.state;
    if(statePath) {
      Vue.set(statePath, 'savedColumns',  columns)
    }
  },

  tableAddTab(state: any, item: any) {
    if (item.drill) {
      item.title = item.drill[0].nameFull;
      item.id = item.drill[0].id;

      let index = 0;

      if(item.isReplaceTab) {
        index = state.table.activeReports.findIndex((e: any) => e.tabId === state.table.activeTab);
      } else {
        index = state.table.activeReports.findIndex((e: any) => e.id === item.id && e.tabId === state.table.activeTab);
        if(index === -1) {
          index = state.table.activeReports.findIndex((e: any) => e.id === item.id);
        }
      }

      if (index !== -1 && !item.isAddTab) {
        item.state = state.table.activeReports[index].state;
        item.tabId = state.table.activeReports[index].tabId;
        delete item.isAddTab;
        delete item.tabData;

        state.table.activeReports[index] = item;

        if(state.table.activeTab !== item.tabId) {
          store.commit('tableActiveTab', {
            tabId: item.tabId,
          });
        } else {
          store.commit('tableActiveTabStackPush', item.tabId);
        }
      } else {
        item.state = item.tabData
          ? _.cloneDeep(item.tabData)
          : {
            filters:{},
            savedColumns: _.cloneDeep(store.getters.savedColumnsInCurentPreset),
            tableQuery: {
              ...state.table.query,
              search:{},
              offset:{},
              treeLevels: [''],
              view: 'tree',
              tree: new Array(2),
            },
            tableQueryTemporary: {
              ...state.table.queryTemporary,
              search:{},
              treeLevels: [''],
              view: 'tree',
              tree: new Array(2),
            }
          };

        item.tabId = ++nextTabId;
        delete item.isAddTab;

        state.table.activeReports.push(item);

        if(!state.table.activeTab && !item.tabData) {
          state.table.activeTab = nextTabId;
        } else {
          delete item.tabData;
          store.commit('tableActiveTab', {
            tabId: nextTabId
          });
        }
      }
    }
  },

  tableRemoveTab(state: any, item: any) {
    state.table.activeReports.splice(state.table.activeReports.map((e: any) => e.id).indexOf(item.id), 1);
    if (!state.table.activeReports.length)
      state.table.selectedReport = null;
  },

  tableRenameTab(state: any, data: any) {
    state.table.activeReports.forEach((e: any) => {
      if (e.id === data.id) {
        e.title = data.nameFull;
      }

      if(e.drill) {
        e.drill.forEach((item: any) => {
          if(item.id === data.id) {
            item.name = data.name;
            item.nameFull = data.nameFull;
          }
        });
      }
    });
  },

  tableActiveReports(state: any, item: any) {
    if (item._remove) {
      state.table.activeReports.splice(state.table.activeReports.map((e: any) => e.id).indexOf(item.id), 1);
      if (!state.table.activeReports.length)
        state.table.selectedReport = null;
      return;
    }

    if (item.drill) {
      item.title = item.drill[0].nameFull;
      item.id = item.drill[0].id;
      let index = state.table.activeReports.map((e: any) => e.id).indexOf(item.id);
      if (index !== -1) {
        state.table.activeReports[index] = item;
        state.table.activeReports.push(state.table.activeReports.pop())
      }
      else {
        state.table.activeReports.push(item);
      }
    }

  },

  tableCustomGroups(state: any, data: any) {
    state.table.customGroups = data;
  },

  tableNextReportGroup(state: any, data: any) {
    state.table.nextReportGroup = data;
  },

  tableTreeLevels(state: any, data: any) {
    const statePath = state.table.activeReports?.find(report => report.tabId === state.table.activeTab)?.state.tableQuery
    if (!statePath) return;
    Vue.set(statePath, 'treeLevels', data);
  },

  tableTreeLevelsTemporary(state: any, data: any) {
    const statePath = state.table.activeReports?.find(report=>report.tabId === state.table.activeTab)?.state?.tableQueryTemporary
    if(!statePath) return;
    if (data) {
      Vue.set(statePath, 'treeLevels', data);
    } else {
      Vue.set(statePath, 'treeLevels', null);
    }
  },

  tableView(state: any, data: any) {
    const statePath = state.table.activeReports?.find(report => report.tabId === state.table.activeTab)?.state.tableQuery
    if (!statePath) return;
    Vue.set(statePath, 'view', data);
  },

  tableViewTemporary(state: any, data: any) {
    const statePath = state.table.activeReports?.find(report=>report.tabId === state.table.activeTab)?.state?.tableQueryTemporary
    if(!statePath) return;
    Vue.set(statePath, 'view', data);
  },
  
  tableTree(state: any, data: any) {
    const statePath = state.table.activeReports.find(report=>report.tabId === state.table.activeTab).state.tableQuery.tree

    Vue.set(statePath, data.index, data.value);
  },

  tableTreeTemporary(state: any, data: any) {
    const statePath = state.table.activeReports.find(report=>report.tabId === state.table.activeTab).state.tableQueryTemporary.tree

    Vue.set(statePath, data.index, data.value);
  },

  clearTableTree(state: any, data: any) {
    const statePath = state.table.activeReports.find(report=>report.tabId === state.table.activeTab).state.tableQuery.tree

    Vue.set(statePath, 'tree',[]);
  },

  tableSelectedItems(state: any, data: any) {
    if (!data) {
      state.table.selectedItems = [];
      return;
    }

    state.table.selectedItems = data;
  },

  tableLoading(state: any, data: any) {
    state.table.loading = data;
  },

  tableCurrentReport(state: any, data: any) {
    state.table.currentReport = data;
  },

  tableSelectedReport(state: any, data: any) {
    state.table.selectedReport = data;
  },

  tableNotesOpened(state: any, data: any) {
    state.table.notesOpened = data;
  },

  tableChartOpen(state: any, data: any) {
    state.table.chartOpen = data;
    window.localStorage.setItem('table-chart-open', data);
  },
  tableChartHiddenSeries(state: any, data: any) {
    Vue.set(state.table.chartHiddenSeries,data.id, data.value);
    window.localStorage.setItem('table-chart-hidden-series', JSON.stringify(state.table.chartHiddenSeries));
  },
  tableClearChartHiddenSeries(state: any) {
    Vue.set(state.table, 'chartHiddenSeries', {});
    window.localStorage.setItem('table-chart-hidden-series', JSON.stringify(state.table.chartHiddenSeries));
  },
  tableChartHiddenSeriesDashboard(state: any, data: any) {
    Vue.set(state.table.chartHiddenSeriesDashboard,data.id, data.value);
    window.localStorage.setItem('table-chart-hidden-series-dashboard', JSON.stringify(state.table.chartHiddenSeriesDashboard));
  },
  tableAddFilter(state: any, data: any) {
    let statePath = state.table.filters;
    if(state.table.activeTab !==0 ){
      statePath = state.table.activeReports.find(report=>report.tabId === state.table.activeTab).state.filters
    }

    if(data.filterHaving) {
      Vue.set(statePath, data.filterHaving, data);
    }
  },
  tableRemoveColumnsFilter(state: any, data: any) {
    let statePath = state.table.filters;
    if(state.table.activeTab !==0 ){
      statePath = state.table.activeReports.find(report=>report.tabId === state.table.activeTab).state.filters
    }
    if(data) {
      Vue.delete(statePath, data);
    }
  },
  tableSetColumnsFilters(state, data) {
    let statePath = state.table.filters;
    if(state.table.activeTab !==0 ){
      statePath = state.table.activeReports.find(report=>report.tabId === state.table.activeTab).state.filters
    }
    Vue.delete(statePath, data);
  },
  tableIsHideFilters(state: any, data: boolean) {
    state.table.isHideFilters = data;
  },
  tableSettingsTabRoute(state: any, data: string) {
    state.table.settingsTabRoute = data;
  },
  tableNoReportBlockVisible(state: any, data: boolean) {
    state.table.noReportBlockVisible = data;
  },
  tableProgressBlockVisible(state: any, data: boolean) {
    state.table.progressBlockVisible = data;
  },
  tableMenuOverride(state: any, data: string) {
    state.table.menuOverride = data;
  },
  tableEntityNames(state: any, data: any) {
    Vue.set(state.table.entityNames, data.key, data.value);
  },
  tableActiveTabStackPush(state: any, tabId: number) {
    const pushCondition = 
      state.table.activeTabStack[state.table.activeTabStack.length - 1] !== tabId
      && (
        tabId <= 0 
        || state.table.activeReports.some((item: any) => item.tabId === tabId)
      );

    if(pushCondition) {
      state.table.activeTabStack.push(tabId);
    }
  },
  tableActiveTabStackPop(state: any, closedTabId: number) {
    let { activeTabStack } = state.table;
    activeTabStack = activeTabStack.filter((item: number) => item !== closedTabId);

    if(closedTabId === state.table.activeTab){
      const nextTabId = activeTabStack.pop() || 0;
      store.commit('tableActiveTab', {
        tabId: nextTabId
      });
    }

    state.table.activeTabStack = activeTabStack;
  },
  tableCustomEvents(state: any, value: any) {
    state.table.customEvents = value.reduce((acc, item) => {
      acc[item.slug] = item;
      return acc;
    }, {})
  },
  setReportBoost(state: any, value: any) {
    Vue.set(state.table, 'reportBoostEnabled', value);
    window.localStorage.setItem('report-boost-enabled', value);
  },
};
